import React, { useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import { IBooking } from 'shared-types/SharedTypes';
import BookingCardContainer from 'booking-card-list/BookingCardContainer/BookingCardContainer';
import DateUtilsService from 'external-services/date-utils-service';
import { LocaleService } from 'internal-services/locale/locale.service';
import GreyDivider from 'app/common/Divider/GreyDivider';
import styles from './style.module.scss';

interface ConflictItemProps {
  conflict: any;
  conflictTableId: string | null;
  handleStatusChange: (bookingId: string, statusId: string) => void;
  handleBookingClicked: (booking: IBooking) => void;
}

const ConflictItem = ({
  conflict,
  conflictTableId,
  handleStatusChange,
  handleBookingClicked
}: ConflictItemProps) => {
  const dateHeader = useMemo(() => {
    return LocaleService.formatDate(conflict.firstBooking.time, 'weekday-long-month');
  }, [conflict.firstBooking.time]);

  const startTime = useMemo(() => {
    return DateUtilsService.dateToTimeStr12Hour(conflict.secondBooking.time);
  }, [conflict.secondBooking.time]);

  const endTime = useMemo(() => {
    return DateUtilsService.dateToTimeStr12Hour(conflict.firstBooking.bookingEnd);
  }, [conflict.firstBooking.bookingEnd]);

  const doRender = (conflictTableId && (conflict.table._id === conflictTableId)) || !conflictTableId;

  if (!doRender) {
    return null;
  }

  return (
    <Box
      key={`${conflict.firstBooking._id}-${conflict.secondBooking._id}`}
      className={styles.conflictGroup}
    >
      {/* Conflict Header */}
      <Box className={styles.conflictHeader}>
        <Typography className={styles.conflictDescription}>
          Table {conflict.table.name} has bookings that overlap from {startTime} to {endTime}.
        </Typography>
      </Box>

      {/* First Booking */}
      <Box>
        <BookingCardContainer
          booking={conflict.firstBooking}
          handleBookingStatusClicked={({ statusId, bookingId }) => handleStatusChange(bookingId, statusId)}
          handleBookingClicked={() => handleBookingClicked(conflict.firstBooking)}
        />
        <GreyDivider />
      </Box>
      {/* Second Booking */}
      <Box>
        <BookingCardContainer
          booking={conflict.secondBooking}
          handleBookingStatusClicked={({ statusId, bookingId }) => handleStatusChange(bookingId, statusId)}
          handleBookingClicked={() => handleBookingClicked(conflict.secondBooking)}
        />
        <GreyDivider />
      </Box>
    </Box>
  );
};

export default ConflictItem;
